<template>
  <div>
    <b-modal
      id="projectCreateModal"
      :title="title"
      size="lg"
      lazy
      :no-close-on-backdrop="true"
      ok-title="Vista"
      cancel-title="Hætta við"
      @ok.prevent="validateBeforeSubmit"
      :ok-disabled="loading"
      ref="createModal"
    >
      <div>
        <b-form @submit.prevent="validateBeforeSubmit" novalidate>
          <b-form-group
            label="Heiti:"
            label-for="name"
            :state="submitted && errors.has('name') ? false : ''"
            :invalid-feedback="errors.first('name')"
            description="Heiti verkefnategundar"
          >
            <b-form-input
              id="name"
              name="name"
              autofocus
              type="text"
              v-model="form.name"
              required
              :state="submitted && errors.has('name') ? false : ''"
              v-validate="'required'"
              data-vv-as="nafn"
            ></b-form-input>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import attendance from '@/api/attendance';
import { djangoErrorsToVee } from '@/utils';

export default {
  name: 'project-create-modal',
  data() {
    return {
      loading: false,
      submitted: false,
      errorList: [],
      projectId: '',
      title: 'Stofna verkefnategund',
      form: {
        name: '',
      },
    };
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const response = await attendance.attendanceProjectDetail(this.projectId);
        this.form.name = response.data.name;
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    async validateBeforeSubmit() {
      try {
        this.submitted = true;
        this.errorList = [];
        await this.$validator.validateAll().then(response => {
          if (!response) throw 'FormValidationError'; // eslint-disable-line no-throw-literal
        });

        // Engar villur í formi.
        try {
          this.loading = true;
          if (this.projectId) {
            await attendance.attendanceProjectUpdate(this.projectId, {
              name: this.form.name,
            });
            this.displaySuccess(`Verkefnategundinni „${this.form.name}“ hefur verið breytt.`);
          } else {
            await attendance.attendanceProjectCreate({
              name: this.form.name,
            });
            this.displaySuccess(`Verkefnategundin „${this.form.name}“ hefur verið stofnuð.`);
          }
          this.$emit('successful', {});
          this.$refs.createModal.hide();
        } catch (e) {
          // Aðgerð mistókst.
          this.failed = true;
          this.$log.debug(e);
          if (e.response && e.response.status === 400) {
            djangoErrorsToVee(e.response.data, this.errors, this.errorList);
          } else {
            this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
          }
        }
      } catch (e) {
        // Villur í formi.
        this.$log.debug(e);
      }
    },
    show(projectId) {
      this.form.name = '';
      this.submitted = false;
      this.loading = false;
      this.projectId = null;
      this.title = 'Srká verkefnategund';
      if (projectId) {
        this.title = 'Breyta verkefnategund';
        this.projectId = projectId;
        this.load();
      }
      this.$refs.createModal.show();
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
};
</script>
<style lang="scss"></style>
